import { post } from './http'
import { LOGIN } from '../utils/routes'

export const loginUser = (payload) => post(LOGIN, payload)
